import { useEffect, useState } from "react";
import { BrandMark } from "./BrandMark.js";

export function StartupLoader({ delayed = true }: { delayed?: boolean }) {
  const [visible, setVisible] = useState(!delayed);

  useEffect(() => {
    if (!delayed) return;
    const timer = window.setTimeout(() => setVisible(true), 180);
    return () => window.clearTimeout(timer);
  }, [delayed]);

  if (!visible) return null;

  return (
    <main className="startup-loader" aria-label="Loading Conferis" aria-live="polite">
      <BrandMark className="startup-loader__mark" data-testid="startup-brand-mark" />
      <span className="startup-loader__progress" aria-hidden="true" />
    </main>
  );
}
